<template>
    <li class="nav-item" :class="{ collapsed: isCollapsed }">
       <!-- <a :href="link.path">
          <i :class="link.icon"></i>
          <span class="nav-link-text">{{ link.name }}</span>
        </a> -->
        <router-link :data-testid="`module-${toSlug(link.name)}`"
                :to="link.path"
                @click.native="linkClick"
                class="nav-link"
                :class="{ 'nav-link-collapsed': isCollapsed }"
                :target="link.target"
                :href="link.path"
                :title="isCollapsed ? link.name : null">
            <template>
                <i :data-testid="`module-icon-${toSlug(link.name)}`" :class="link.icon"></i>
                <span :data-testid="`module-label-${toSlug(link.name)}`" class="nav-link-text">{{ link.name }}</span>
            </template>
        </router-link>
    </li>
</template>
<script>
  export default {
    name: 'sidebar-item',
    props: {
      link: {
        type: Object,
        default: () => {
          return {
            name: '',
            path: '',
            children: []
          };
        },
        description:
          'Sidebar link. Can contain name, path, icon and other attributes. See examples for more info'
      }
    },
    inject: {
      autoClose: {
        default: true
      }
    },
    data() {
      return {
        children: [],
        collapsed: true
      };
    },
    computed: {
      isCollapsed() {
        return this.$sidebar && this.$sidebar.isMinimized;
      }
    },
    methods: {
      linkClick() {
        if (
          this.autoClose &&
          this.$sidebar &&
          this.$sidebar.showSidebar === true
        ) {
          this.$sidebar.displaySidebar(false);
        }
      },
      toSlug(str) {
        return str
          .toLowerCase()          // make all letters lowercase
          .trim()                 // remove leading/trailing spaces
          .replace(/\s+/g, '-')    // replace spaces with dashes
          .replace(/[^a-z0-9-]/g, ''); // remove any non-alphanumeric except dashes
      }
    }
  };
</script>
<style scoped>
.nav-link-collapsed {
  justify-content: center;
}

.nav-link-collapsed > i {
  min-width: 0;
  margin-right: 0;
}

.nav-link-collapsed .nav-link-text {
  display: none;
}
</style>
